import { object, string, boolean, number } from '@gogame/schemas';

import {
  DISPLAY_NAME,
  METRIC_TYPE,
  CUSTOM_METRIC,
  CHART_AXIS_GROUP_ID,
  IS_AVAILABLE_FOR_CHART,
} from './constants';

export const customMetricValidationSchema = object({
  [DISPLAY_NAME]: string()
    .matches(/[a-zA-Z]/, `Metric's title should contain at least one letter`)
    .max(60, "Metric name can't exceed 60 characters")
    .required('Name is required'),
  [METRIC_TYPE]: string().required('Metric type is required').default('number'),
  [CUSTOM_METRIC]: object().required('Formula is required'),
  [IS_AVAILABLE_FOR_CHART]: boolean().default(false),
  [CHART_AXIS_GROUP_ID]: number().when(
    IS_AVAILABLE_FOR_CHART,
    (isAvailableForChart, schema) => {
      if (!isAvailableForChart) {
        return schema;
      }
      return schema.required('Chart group is required');
    }
  ),
});
